import { c as _c } from "react/compiler-runtime";
import { spacing } from '@cc-shopping/ui/theme';
import { Box, Typography } from '@mui/material';
import { EmptyCard, RemoveCard } from './Icons';
type CardMessageProps = {
  message: string;
  icon?: keyof typeof iconMapper;
};
const iconMapper = {
  emptyCard: EmptyCard,
  removeCard: RemoveCard
};
export const CardMessage = t0 => {
  const $ = _c(8);
  const {
    message,
    icon
  } = t0;
  const Icon = icon ? iconMapper[icon] : null;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = spacing(2);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== Icon) {
    t2 = Icon && <Icon />;
    $[1] = Icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== message) {
    t3 = <Box maxWidth="343px" textAlign="center"><Typography>{message}</Typography></Box>;
    $[3] = message;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Box display="flex" flexDirection="column" alignItems="center" gap={t1}>{t2}{t3}</Box>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};